import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const opApi = axios.create({ baseURL: API, withCredentials: true });

const TOKEN_KEY = "sm_op_token";

opApi.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

const OpContext = createContext({ operator: null, loading: true });

export function OperatorProvider({ children }) {
  const [operator, setOperator] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await opApi.get("/app/me");
      setOperator(r.data);
    } catch {
      setOperator(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (operatorId, pin) => {
    const r = await opApi.post("/app/login", { operator_id: operatorId, pin });
    if (r.data.token) localStorage.setItem(TOKEN_KEY, r.data.token);
    setOperator(r.data.operator);
    return r.data;
  }, []);

  const logout = useCallback(async () => {
    try { await opApi.post("/app/logout"); } catch { /* ignore */ }
    localStorage.removeItem(TOKEN_KEY);
    setOperator(null);
  }, []);

  return (
    <OpContext.Provider value={{ operator, loading, login, logout, refresh }}>
      {children}
    </OpContext.Provider>
  );
}

export function useOperator() { return useContext(OpContext); }
